import { PaymentTypeEnum } from "./V2/gozer"

export const PaymentMethodTypes = [
    {
        name: "Credit Card",
        value: PaymentTypeEnum.CC
    },
    {
        name: "E-Check",
        value: PaymentTypeEnum.ACH
    },
    {
        name: "Other",
        value: PaymentTypeEnum.OTHER
    },
    {
        name: "Cash",
        value: PaymentTypeEnum.CASH
    },
    {
        name: "Check",
        value: PaymentTypeEnum.CHECK
    },
    {
        name: "Money Order",
        value: PaymentTypeEnum.MONEY_ORDER
    }
].sort((a,b) => a?.name?.localeCompare(b?.name ?? "") ?? 0)